<template>
<div style="height:100vh">
  <pull-to
    class="b_personal_page"
    @infinite-scroll="loadMoreWish"
    :is-top-bounce="false"
    :is-bottom-bounce="false"
  >
    <div
      class="container wishes_wrap personal_page"
      :class="[{noBirthInfo:!birthdayPersonInfo.hasBirthday},{today:birthdayPersonInfo.daysFromBirthday==0}]"
    >
      <div class="wishMainWrap" v-if="dataLoaded&&!wishDetailIsDel">
        <!-- 生日当天的界面 -->
        <div class="info_wrap" v-if="birthdayPersonInfo.hasBirthday">
          <div class="b_user_info">
            <div class="user_tag">
                <template v-if="birthdayPersonInfo.useOpenData">
                    <span>
                        {{birthdayPersonInfo.realName | firstName}}
                    </span>
                </template>
                <template v-else>
                    <span>
                        {{ birthdayPersonInfo.realName | lastName}}
                    </span>
                </template>
              
              <i></i>
            </div>
            <dl>
                <dt>
                    <Organization :name="birthdayPersonInfo.realName" type="userName" :openid="birthdayPersonInfo.memberKeyRaw" :useOpenData="birthdayPersonInfo.useOpenData" ></Organization>
                </dt>
              <dd>{{birthdayPersonInfo.birthday}}&nbsp;|&nbsp;{{birthdayPersonInfo.constellation}}</dd>
              <dd v-if="wishList.totalRecord>=0">已收到 {{wishList.totalRecord}} 份爱与祝福</dd>
            </dl>
          </div>
          <div class="day_timer" v-if="birthdayPersonInfo.daysFromBirthday==0">
            <p>生日快乐</p>
          </div>
          <div
            class="day_timer"
            v-if="birthdayPersonInfo.daysFromBirthday&&birthdayPersonInfo.daysFromBirthday>0 && birtdayDays > 0"
          >
            <p>距离生日(天)</p>
            <div class="days">
              <span v-for="item in getDaysText(birthdayPersonInfo.daysFromBirthday)">{{item}}</span>
            </div>
          </div>
          <div
            class="day_timer"
            v-if="birthdayPersonInfo.daysFromBirthday&&birthdayPersonInfo.daysFromBirthday>0 && birtdayDays < 0"
          >
            <p>已过生日(天)</p>
            <div class="days">
              <span v-for="item in getDaysText(Math.abs(birtdayDays))">{{item}}</span>
            </div>
          </div>
        </div>
        <!-- 没生日信息 -->
        <div class="no_bir_info" v-if="!birthdayPersonInfo.hasBirthday">
          <div class="user_info_wrap">
            <div class="user_tag">
                <template v-if="birthdayPersonInfo.useOpenData">
                    <span>
                        {{birthdayPersonInfo.realName | firstName}}
                    </span>
                </template>
                <template v-else>
                    <span>
                        {{ birthdayPersonInfo.realName | lastName}}
                    </span>
                </template>
              <i></i>
            </div>
            <p class="b_user_name">{{birthdayPersonInfo.realName}}</p>
          </div>
          <div class="no_bir_tips">
            <img src="../../assets/img/birthday/no_birthday_info.png" />
            <dl>
              <dt>还没有生日信息哦</dt>
              <dd>联系管理员添加</dd>
            </dl>
          </div>
        </div>
        <div v-if="birthdayPersonInfo.hasBirthday">
          <div class="outer_wish">
            <!-- 别人进入主页才可以送祝福 -->
            <div v-if="birthdayPersonInfo.type=='others'">
              <div class="title_wrap">
                <span class="title_line"></span>
                <h2>选礼物 送祝福</h2>
                <span class="title_line"></span>
              </div>
              <ul class="gifts">
                <li v-for="(item,index) in wishImageList.imagesList">
                  <div
                    class="img_wrap"
                    @click.prevent="selectWishFun(index,item.id)"
                    :class="[wishedSelectedIndex==index?'active':'']"
                  >
                    <img :src="item.url" alt />
                  </div>
                  <p>{{item.title}}</p>
                </li>
              </ul>
              <div class="wishes_operation" v-if="birthdayPersonInfo">
                <template v-if="birthdayPersonInfo.wishType == 1">
                  <textarea
                    class="wish_text"
                    placeholder="输入生日祝福语（200字以内均可）"
                    v-model="wishInfo.content"
                    maxlength="200"
                  ></textarea>
                  <!-- 长按是的按钮样式class  touched-->
                  <!--  <a href="javascript:;" class="video_opt_btn" v-if="isWXEnv&&!recordId" :class="{touched:voiceBtnActive}" v-touch:touchstart="recordStartFun"  v-touch:touchend="recordEndFun">按住 <i class="voice_icon"></i> 说悄悄话
                  </a>-->
                  <div class="c_video_opt_btn" v-if="!isMobile||!isWXEnv">
                    未发现录音设备
                    <i class="canot_voice_icon"></i> 请在微信中使用
                  </div>
                 <template v-else>
                      <a
                    href="javascript:;"
                    v-if="isWXEnv&&recordBtnStaus==1&&!recordId"
                    class="video_opt_btn"
                    @click="recordStartFun"
                  >
                    点击
                    <i class="voice_icon"></i>开始录音
                  </a>
                  <a
                    href="javascript:;"
                    v-if="isWXEnv&&recordBtnStaus==2&&!recordId"
                    class="video_opt_btn stop"
                    :class="{touched:voiceBtnActive}"
                    @click="recordEndFun"
                  >
                    点击
                    <i class="voice_icon"></i>停止录音
                  </a>
                 </template>
                  
                  <div class="vedio_play_wrap" v-show="recordId">
                    <div class="vedio_main">
                      <audio :src="wishInfo.voiceUrl" class="recordVoice"></audio>
                      <a
                        href="javascript:;"
                        class="play_btn"
                        @click="recordPlayFun"
                        ref="audioPlayBtn"
                      ></a>
                      <div class="vedio_progress">
                        <div class="progress_all">
                          <div class="progress_play" :style="recordPlayProgress"></div>
                        </div>
                        <div class="times">
                          <span class="play_time_count">{{soundRecordTimePlay}}</span>
                          <span class="vedio_all_time">{{soundRecordTime}}</span>
                        </div>
                      </div>
                    </div>
                    <a href="javascript:;" class="video_del_btn" @click="soundRecordDel"></a>
                  </div>
                </template>
                <a
                  href="javascript:;"
                  class="btn btn-default add_wish_btn"
                  :class="{disable:!canWish}"
                  @click="addWishFun"
                >
                  <i v-if="adding"></i>
                  {{addText}}
                </a>
              </div>
            </div>
            <!-- 是自己进入主页才能看到福利 目前缺少企业福利接口-->
            <div
              class="comany_wishes"
              v-if="birthdayPersonInfo.type=='my'&&careWelfareList.length>0"
            >
              <div class="title_wrap" v-if="birthdayCareWelfare.titleType==1">
                <span class="title_line"></span>
                <h2>企业生日关怀</h2>
                <span class="title_line"></span>
              </div>
              <div class="title_wrap" v-if="birthdayCareWelfare.titleType==2">
                <span class="title_line"></span>
                <h2>企业生日福利</h2>
                <span class="title_line"></span>
              </div>
              <ul class="welfare_list">
                <li class="welfare_item" v-for="item in careWelfareList">
                  <div class="img_box">
                    <img :src="item.img" alt />
                  </div>
                  <div class="infos">
                    <dl>
                      <dt>{{item.title}}</dt>
                      <dd
                        v-if="item.welfareCategory==0||item.welfareCategory==3"
                      >{{item.description}}</dd>
                      <dd
                        v-if="item.welfareCategory==1||item.welfareCategory==2||item.welfareCategory==5"
                      >领取截止日期：{{item.endDate}}</dd>
                    </dl>
                    <div class="btn_wrap">
                      <a
                        :href="item.redirectUrl"
                        class="btn btn-default"
                        v-if="(item.welfareCategory==1||item.welfareCategory==2||item.welfareCategory==5)&&item.status==3"
                      >领取福利</a>
                      <a
                        :href="item.redirectUrl"
                        class="btn btn-line"
                        v-if="(item.welfareCategory==1||item.welfareCategory==2||item.welfareCategory==5)&&item.status==1"
                      >查看福利</a>
                      <a
                        :href="item.redirectUrl"
                        class="btn btn-line"
                        v-if="(item.welfareCategory==1||item.welfareCategory==2||item.welfareCategory==5)&&item.status==6"
                      >已过期</a>
                      <a
                        :href="item.redirectUrl"
                        class="btn btn-default"
                        v-if="item.welfareCategory==0||item.welfareCategory==3"
                      >立即查看</a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="wishes_board">
            <div class="title_margin"></div>
            <div
              class="share-btn"
              v-if="birthdayPersonInfo.blessingButtonStatus =='1' && birthdayPersonInfo.type=='my' "
            >
              <a
                @click="showBlessingFn"
                :href="'/customize/desaysv.html?sub_uid='+birthdayPersonInfo.subUid"
              >
                <img src="../../assets/img/birthday/show_btn.png" alt />
              </a>
            </div>
            <div class="title_wrap">
              <span class="title_line"></span>
              <h2>祝福留言</h2>
              <span class="title_line"></span>
            </div>

            <div class="title_margin"></div>
            <!-- 没有收到生日福利或祝福 -->
            <div
              class="no_wishes_get"
              v-if="birthdayPersonInfo.type=='my'&&wishList.totalRecord<=0&&!wishDetailItem.id"
            >
              <img src="../../assets/img/birthday/no_wishes.png" />
              <p>小伙伴们可能太忙了，别泄气呀</p>
            </div>
            <div
              class="no_wishes_get"
              v-if="birthdayPersonInfo.type=='others'&&wishList.totalRecord<=0&&!wishDetailItem.id"
            >
              <img src="../../assets/img/birthday/no_wishes.png" />
              <p>还没有祝福留言，赶紧提交祝福吧</p>
            </div>
            <div>
              <div class="wish_board_item" v-for="item in wishListItems">
                <div class="b_user_tag">
                    <template v-if="item.useOpenData">
                        {{item.fromName | firstName}}
                    </template>
                    <template v-else>
                        {{item.fromName | lastName}}
                    </template>
                </div>
                <div class="b_wish_messages">
                    <p class="b_user_name">
                        <span><Organization :name="item.fromName" type="userName" :openid="item.memberKeyRaw" :useOpenData="item.useOpenData" ></Organization></span>
                    </p>
                  <!-- <p class="b_date">2017.08.30<span>12:30</span></p> -->
                  <p class="wish_text_get">{{item.content}}</p>
                  <div class="wish_gift_img" v-if="item.imageUrl">
                    <img :src="item.imageUrl" />
                    <p>{{item.imageDescription}}</p>
                  </div>
                  <template v-if="item.voiceUrl">
                    <myAudio :audioSrc="item.voiceUrl"></myAudio>
                  </template>
                  <div class="opt_wrap">
                    <p class="b_date">{{item.createAt}}</p>
                    <div class="wish_btns">
                      <a
                        href="javascript:;"
                        class="answer_wishes"
                        v-if="item.canReply && birthdayPersonInfo.wishType == 1"
                        @click="addWishReply(item.id,item.fromName)"
                      >回复</a>
                      <span v-if="item.canReply">·</span>
                      <a
                        href="javascript:;"
                        class="del_wishes"
                        v-if="item.canDel"
                        @click="delWishFun(item.id)"
                      >删除</a>
                    </div>
                  </div>
                  <div
                    class="wishes_back_item"
                    v-for="(ritem,index) in item.wishReplyList"
                    :class="'wsb_'+((index+1)%7)"
                  >
                    <div class="b_user_tag">
                        <template v-if="item.useOpenData">
                            {{item.toName | firstName}}
                        </template>
                        <template v-else>
                            {{item.toName | lastName}}
                        </template>
                    </div>
                    <div class="b_wish_messages">
                      <p class="b_user_name">
                          <Organization :name="item.toName" type="userName" :openid="birthdayPersonInfo.memberKeyRaw" :useOpenData="birthdayPersonInfo.useOpenData" ></Organization>
                        <span>回复</span>
                        <span><Organization :name="item.replyName" type="userName" :openid="item.memberKeyRaw" :useOpenData="item.useOpenData" ></Organization></span>
                        <!-- {{ritem.replyName}} -->
                      </p>

                      <p class="wish_text_get">{{ritem.content}}</p>
                      <div class="opt_wrap">
                        <p class="b_date" v-if="ritem.createAt">{{ritem.createAt}}</p>
                        <div class="wish_btns">
                          <a
                            href="javascript:;"
                            class="del_wishes"
                            v-if="ritem.canDel"
                            @click="delReplyFun(ritem.id)"
                          >删除</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="loading_bar" v-if="isShowLoadingBar">加载中...</div>
        <div class="send-success" v-show="success">
          <img src="../../assets/img/birthday/success_icon.png" alt />
          <p>祝福已送达</p>
        </div>
        <div class="tips" v-show="commonTips">{{commonTipText}}</div>
        <div class="sound_record_layer" v-if="soundRecording">
          <img src="../../assets/img/birthday/voice_w_icon.png" height="76" width="53" alt />
          <p>{{soundRecordTime}}</p>
          <span>请控制在60s内</span>
        </div>
      </div>
      <div class="no_in_main_org" v-if="noInMainOrg">
        <img src="../../assets/img/birthday/no_birthday_info.png" />
        <dl>
          <dt>还没有生日信息哦</dt>
          <dd>联系管理员添加</dd>
        </dl>
      </div>

      <loading v-show="isShowLoading"></loading>
      <!-- 提示弹框 -->
      <div v-show="tipDialog" class="self-dialog-pop" ref="dialogWrap">
        <div class="self-dialog-content">
          <div class="content-wrap">
            <p>{{tipText}}</p>
          </div>
          <div class="btn-wraps">
            <a href="javascript:;" class="btn-txt" @click="hideMsg">知道啦</a>
          </div>
        </div>
      </div>
      <my-dialog
        :dialogtype="dialogType"
        :operid="operId"
        @wishdel="delWishDetailItemFun"
        @close="dialogCloseFun"
      ></my-dialog>
    </div>
    <home :ishome="0"></home>
  </pull-to>
  </div>
</template>
<script>
import loading from "../common/loading.vue";
import myDialog from "./dialog.vue";
import myAudio from "./audio.vue";
import PullTo from "vue-pull-to";
import Cookies from "js-cookie";
import home from "../common/home.vue";
import Organization from "@/components/common/organization.vue";
import { mapGetters, mapActions } from "vuex";

// var loadjs = require("loadjs");
export default {
  data() {
    return {
      // loading:true,
      isHasWishes: true,
      noBirthDayInfo: false,
      success: false,
      adding: false,
      voiceBtnActive: false,
      dataLoaded: false,
      isShowLoading: false,
      tipDialog: false,
      tipText: "",
      commonTips: false,
      commonTipText: "",
      wishedSelectedIndex: -1,
      curPage: 1,
      pageSize: 10,
      showWishList: false,
      cannoRecordTips: "无法获取录音设备，建议在微信或企业微信里使用",
      wishInfo: {
        imageId: "",
        content: "",
        toSubUid: "",
        voiceUrl: ""
      },
      wishDetailItem: {
        wishReplyList: []
      },
      wishListItems: [],
      careWelfareList: [],
      isShowLoadingBar: false,
      soundRecording: false, //录音相关
      recordBtnStaus: 1, //1开始录音，2停止录音
      soundRecordTime: "00:00",
      soundRecordTimePlay: "00:00",
      isAbleRecord: false,
      isAbleRecordTimer: "",
      recordStartTime: "",
      recordEndTime: "",
      recordTimer: "",
      recordTimeCount: 0,
      wxActions: "",
      recordId: "",
      recordServerId: "",
      recordPlayProgress: {
        width: "0%"
      },
      playTimer: "",
      canAddWishBtnClick: true,
      wishDetailIsDel: false,
      noInMainOrg: false,
      doWishDetailDel: false,
      dialogType: 0, //弹框的属性
      operId: 0, //弹框的属性
      canWish: false, // 是否可以祝福
      birtdayDays: 0, // 还有多天过生日，负数为已经过了多少天
      wxShareData: {},
      ddShareData: {},
      share_info: {},
      show_open_data:false,
      use_open_data:false
    };
  },
  components: {
    loading,
    myAudio,
    PullTo,
    myDialog,
    home,
    Organization
  },
  computed: {
    ...mapGetters({
      userLoginFinish: "userLoginFinish",
      wishImageList: "getWishImageList",
      birthdayPersonInfo: "getBirthdayPersonInfo",
      birthdayWishDetail: "getBirthdayWishDetail",
      wishList: "getWishList",
      birthdayIntro: "getBirthdayIntro",
      addWish: "getAddWish",
      delWishReply: "getDelWishReply",
      delWish: "getDelWish",
      birthdayCareWelfare: "getBirthdayCareWelfare"
    }),
    wishId() {
      return this.$route.query.wishId;
    },
    subUid() {
      console.log("this.$route.query.subUid;", this.$route.query.subUid);
      return this.$route.query.subUid;
    },
    isMobile(){
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("mobile") !== -1 || ua.indexOf("iphone") !== -1
    },
    isWXEnv() {
      return this.isWX();
    },
    queryCorpId() {
      return this.$route.query.corpId;
    },
    addText() {
      if (this.adding) {
        return "提交中";
      } else {
        return "提交祝福";
      }
    }
  },
  watch: {
    userLoginFinish(cval) {
      if (cval) {
        this.initPageData();
      }
    },
    birthdayPersonInfo(cval) {
      this.isShowLoading = false;
      if (!cval) {
        this.showCommonTips("不在一家公司不能互相祝福哦！");
        return;
      }
      if (typeof cval == "object") {
        this.dataLoaded = true;
        this.noInMainOrg = false;
        //去生日蜡烛页面
        this.$store.dispatch("doBirthdayIntro", { subUid: cval.subUid });
      } else {
        this.noInMainOrg = true;
      }

      // 计算是否可以祝福
      if (this.birthdayPersonInfo.wishStatus == 1) {
        this.canWish = this.getCanWish(
          this.birthdayPersonInfo.daysFromBirthday
        );
      } else {
        this.canWish = false;
      }

      this.birtdayDays = this.getBirtdayDays(
        this.birthdayPersonInfo.daysFromBirthday
      );
      this.initShare();
    },
    birthdayIntro(cval) {
      if (cval && cval.status) {
        this.$router.push({
          name: "birthdayIntroduction",
          query: {
            name: cval.userName,
            corpId: this.$route.query.corpId
          }
        });
      }
    },
    wishList(cval) {
      if (cval.wishList && cval.wishList.length > 0) {
        this.isShowLoadingBar = false;
        this.wishListItems = this.wishListItems.concat(cval.wishList);
        // console.log("wishbordNODE",document.querySelector('.wishes_board').offsetHeight)
      }
    },
    addWish(cval) {
      console.log("addWish", cval);
      if (!cval) {
        this.adding = false;
        this.showCommonTips("祝福提交失败了！");
        return;
      }
      let wish = cval.toString();
      if (wish.indexOf("error") != -1) {
        this.adding = false;
        this.showCommonTips("祝福提交失败了！");
      } else {
        this.adding = false;
        this.success = true;
        setTimeout(() => {
          this.success = false;
          this.initWishBoard(); //恢复默认无留言是数据
          this.refreshWishList(); //刷新列表
        }, 300);
      }
    },
    delWishReply(cval) {
      this.refreshWishList(); //刷新列表
    },
    delWish(cval) {
      if (this.doWishDetailDel) {
        if (this.subUid) {
          this.$router.push({
            name: "birthdayPersonal",
            query: {
              subUid: this.subUid
            }
          });
        } else {
          this.$router.push({
            name: "birthdayPersonal"
          });
        }
      } else {
        this.refreshWishList(); //刷新列表
      }
    },
    birthdayWishDetail(cval) {
      if (cval.wishDetail) {
        this.wishDetailItem = cval.wishDetail;
      } else {
        this.wishDetailIsDel = true;
        //消息删除页面停止录音
        if (this.isWX()) {
          this.wxActions.stopRecord();
          wx.stopRecord();
        }

        this.isShowLoading = false;
      }
    },
    birthdayCareWelfare(cval) {
      if (cval.list) {
        this.careWelfareList = cval.list;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    //离开组件时停止录音
    console.log("离开页面停止录音");
    if (this.wxActions) {
      this.wxActions.stopRecord();
    }
    if (this.isWX()) {
      wx.stopRecord();
    }
    next();
  },
  created() {
    //用于检测用户是否登录
    // this.$store.dispatch('userSectionCheck');
    //不切换公司的时候直接加载数据
    // if (!this.queryCorpId) {
    //   this.initPageData();
    // }
    this.show_open_data = window.show_open_data;
    this.use_open_data = window.use_open_data;
  },
  filters: {
    lastName: function(value) {
      if (value) {
        return value.substring(value.length - 1, value.length);
      }
    }
  },
  methods: {
    getDaysText(daysFromBirthday) {
      return String(daysFromBirthday).split("");
    },
    getCanWish: function(days) {
      let canWish = false;
      if (days === 0) {
        canWish = true;
        return canWish;
      }
      // 计算是否可以祝福
      if (days > 0 && days <= 50) {
        canWish = true;
      }
      let yearDays = 365;
      if (this.isRenYear()) {
        yearDays = 366;
      }
      if (!canWish) {
        let interval = days - yearDays;
        if (interval > -50) {
          canWish = true;
        }
      }
      return canWish;
    },
    isRenYear: function() {
      let year = new Date().getFullYear();
      return 0 == year % 4 && (year % 100 != 0 || year % 400 == 0);
    },
    getBirtdayDays: function(value) {
      let isRenYear = this.isRenYear();
      let yearDays = 365;
      if (isRenYear) {
        yearDays = 366;
      }
      let days = value;
      let interval = value - yearDays;
      if (interval > -50) {
        days = (yearDays - value + 1) * -1;
      }
      return days;
    },
    showBlessingFn() {
      window.localStorage.setItem("sub_uid", this.birthdayPersonInfo.subUid);
    },
    disableScroll: function() {
      var dialogWrap = this.$refs.dialogWrap;
      dialogWrap.ontouchmove = function(e) {
        e.preventDefault();
      };
    },
    showCommonTips(txt) {
      this.commonTips = true;
      this.commonTipText = txt;
      setTimeout(() => {
        this.commonTips = false;
      }, 800);
    },
    showMsg(txt) {
      this.tipText = txt;
      this.tipDialog = true;
      this.disableScroll();
      if (this.isIOS8()) {
        this.resetIos8DialogTop();
      }
    },
    hideMsg(event) {
      this.tipDialog = false;
    },
    
    isWX() {
      var ua = window.navigator.userAgent.toLowerCase();
      //可以在此方法中屏蔽企业微信录音按钮ua.indexOf('micromessenger') !== -1&&ua.indexOf('wxwork') === -1
      return ua.indexOf("micromessenger") !== -1;
    },
    isWxWork() {
      var ua = window.navigator.userAgent.toLowerCase();
      return /wxwork/i.test(ua);
    },
    isIOS8() {
      var ua = window.navigator.userAgent.toLowerCase();
      return /iphone os ([8]+)_/.test(ua);
    },
    initPageData() {
      // this.$store.dispatch('doBirthdayIntro')
      this.$store.dispatch("doBirthdayWishImageList");
      if (this.subUid) {
        this.$store.dispatch("doBirthdayPersonInfo", { subUid: this.subUid });

        this.$store.dispatch("doBirthdayWishList", {
          subUid: this.subUid,
          pageNumber: this.curPage,
          pageSize: this.pageSize
        });
      } else {
        this.$store.dispatch("doBirthdayPersonInfo");
        this.$store.dispatch("doBirthdayWishList", {
          pageNumber: this.curPage,
          pageSize: this.pageSize
        });
      }
      this.$store.dispatch("getBirthdayCareWelfare");
    },
    initWishBoard() {
      //恢复录音模块的功能
      this.recordId = "";
      this.recordBtnStaus = 1;
      this.recordPlayProgress.width = "0%";
      this.soundRecordTime = "00:00";
      this.soundRecordTimePlay = "00:00";
      //恢复图标的选中
      this.wishedSelectedIndex = -1;
      //重置祝福数据
      Object.assign(this.wishInfo, {
        imageId: "",
        content: "",
        toSubUid: "",
        voiceUrl: ""
      });
    },
    getSeconds(time) {
      return Math.round(
        (((time % (24 * 3600 * 1000)) % (3600 * 1000)) % (60 * 1000)) / 1000
      );
    },
    refreshWishList() {
      this.curPage = 1;
      this.wishListItems = [];
      if (this.subUid) {
        this.$store.dispatch("doBirthdayWishList", {
          subUid: this.subUid,
          pageNumber: this.curPage,
          pageSize: this.pageSize
        });
      } else {
        this.$store.dispatch("doBirthdayWishList", {
          pageNumber: this.curPage,
          pageSize: this.pageSize
        });
      }
    },
    selectWishFun(index, imageId) {
      if (this.wishedSelectedIndex == index) {
        this.wishedSelectedIndex = -1;
        this.wishInfo.imageId = "";
      } else {
        this.wishedSelectedIndex = index;
        this.wishInfo.imageId = imageId;
      }
    },
    // showWishListFun(){
    //   this.showWishList=true;
    // },
    loadMoreWish(loaded) {
      if (this.curPage >= this.wishList.totalPage) {
        return;
      }
      this.isShowLoadingBar = true;
      if (this.subUid) {
        this.$store.dispatch("doBirthdayWishList", {
          subUid: this.subUid,
          pageNumber: ++this.curPage,
          pageSize: this.pageSize
        });
      } else {
        this.$store.dispatch("doBirthdayWishList", {
          pageNumber: ++this.curPage,
          pageSize: this.pageSize
        });
      }
    },
    delReplyFun(replyId) {
      this.dialogType = 3;
      this.operId = replyId;
      // this.$store.dispatch('doBirthdayWishReplyDel',{replyId:replyId});
    },
    delWishDetaiFun(wishId) {
      this.dialogType = 2;
      this.operId = wishId;
      // this.$store.dispatch('doDelWish',{wishId:wishId});
      // this.doWishDetailDel=true;
    },
    delWishDetailItemFun() {
      this.doWishDetailDel = true;
    },
    dialogCloseFun() {
      this.dialogType = 0;
    },
    delWishFun(wishId) {
      this.dialogType = 1;
      this.operId = wishId;
      // this.$store.dispatch('doDelWish',{wishId:wishId});
    },
    addWishReply(replyId, name) {
      this.$router.push({
        name: "birthdayAnswer",
        query: {
          replyId: replyId,
        //   name: name
        }
      });
    },
    addWishFun() {
      if (this.birthdayPersonInfo.wishStatus == 0) {
        return;
      }
      if (!this.canWish) {
        this.showMsg("离Ta生日还很久，过段时间再来吧");
        return;
      }
      this.wishInfo.toSubUid = this.birthdayPersonInfo.subUid;
      if (!this.wishInfo.content && !this.wishInfo.imageId && !this.recordId) {
        this.showMsg("你还没送上祝福哦！");
        return false;
      }
      if (this.adding) {
        console.log("祝福已经在提交中");
        return;
      }
      if (this.recordId) {
        //停止录音播放
        if (this.$refs.audioPlayBtn.classList.contains("play")) {
          this.wxActions.stopVoice(this.recordId);
          this.$refs.audioPlayBtn.classList.remove("play");
          clearInterval(this.playTimer);
        }
        this.adding = true;
        console.log("提交录音祝福", this.recordServerId);
        this.wxActions.getUrl(this.recordServerId, url => {
          console.log("addFungetUrl", url);
          if (url) {
            this.wishInfo.voiceUrl = url;
            console.log("voiceUrl", url);
            console.log("this.wishInfo", this.wishInfo);
            this.$store.dispatch("doBirthdayWishAdd", this.wishInfo);
          } else {
            this.showCommonTips("音频祝福发送失败了！");
            this.adding = false;
          }
        });
      } else {
        console.log("noVoice-wishInfo", this.wishInfo);
        this.adding = true;
        this.$store.dispatch("doBirthdayWishAdd", this.wishInfo);
      }
      //1s内不可以重复提交祝福，防止不小心点击提交两次重复祝福
      // this.canAddWishBtnClick=false;
      // setTimeout(()=>{
      //   this.canAddWishBtnClick=true;
      // },1000);
      // setTimeout(()=>{
      //   if(this.wishInfo.voiceUrl){
      //     this.isShowLoading=false;
      //     this.showMsg("语音提交失败了！")
      //   }
      // },5000);
    },
    recordFunc() {
      //初始化音频事件
      this.soundRecordTime = "00:00";
      console.log("recordstart", event);
      this.recordBtnStaus = 2;
      this.recordStartTime = new Date().getTime();
      this.recordTimeCount = 0;
      // this.wxActions.startRecord();
      this.soundRecording = true;
      this.recordTimer = setInterval(() => {
        this.recordTimeCount++;
        if (this.recordTimeCount < 10) {
          this.soundRecordTime = "00:0" + this.recordTimeCount;
        } else if (this.recordTimeCount <= 59) {
          this.soundRecordTime = "00:" + this.recordTimeCount;
        } else if (this.recordTimeCount > 59) {
          this.soundRecordTime = "01:00";

          this.soundRecording = false;

          this.wxActions.stopRecord(id => {
            this.recordBtnStaus = 1;
            this.recordId = id;
            this.wishInfo.voiceUrl = id;
            if (!id) {
              this.wxActions.onVoiceRecordEnd(id => {
                this.recordId = id;
                this.wishInfo.voiceUrl = id;
                clearInterval(this.recordTimer);
              });
            }
            console.log("停止录音播放mediaid", id);
            if (this.recordId != "") {
              this.wxActions.upload(this.recordId, data => {
                console.log("timeoutmediaid", id);
                this.recordServerId = data["serverId"];
                console.log("timeoutserverId-data", data);
              });
            } else {
              clearInterval(this.recordTimer);
              this.showMsg("录音失败，请刷新页面再试");
              this.soundRecordDel();
            }
          });
          this.recordTimeCount = 60;
          clearInterval(this.recordTimer);
          // wx.stopRecord();
        }
        // console.log("starttime",this.recordTimeCount)
      }, 1000);
    },
    recordStartFun(event) {
      event.preventDefault();
      event.stopPropagation();
      // this.isAbleRecord=false;
      // this.isAbleRecordTimer=setTimeout(()=>{
      //   this.isAbleRecord=true;
      //   this.recordFunc();
      // },400)
      if (this.isWxWork()) {
        this.wxActions.startRecord();
        this.recordFunc();
      } else {
        console.log("微信环境录音");
        this.wxActions.startRecord(status => {
            console.log("录音状态",status);
          if (status === 0) {
            this.showMsg("您取消了麦克风授权，无法录音");
          }
          if (status === 1) {
            this.recordFunc();
          }
        });
      }
    },
    recordEndFun(event) {
      event.preventDefault();
      event.stopPropagation();
      //5ms内不触发录音
      // if(!this.isAbleRecord){
      //   clearTimeout(this.isAbleRecordTimer);
      //   return;
      // }
      console.log("recordend", event);
      this.recordEndTime = new Date().getTime();
      let allTime = Math.round(
        ((((this.recordEndTime - this.recordStartTime) % (24 * 3600 * 1000)) %
          (3600 * 1000)) %
          (60 * 1000)) /
          1000
      );
      console.log("allRecordTime", allTime);
      if (allTime < 3 && this.recordTimeCount < 3) {
        this.wxActions.stopRecord();
        this.recordBtnStaus = 1;
        // wx.stopRecord();
        clearInterval(this.recordTimer);

        this.soundRecording = false;
        this.soundRecordTime = "00:00";
        // this.showMsg("您录制的时间太短了！")
        this.showCommonTips("您录制的时间太短了！");
        return;
      }
      if (this.recordTimeCount >= 60) {
        this.wxActions.stopRecord();
        // wx.stopRecord();
        return;
      }
      this.wxActions.stopRecord(id => {
        this.recordId = id;
        if (!id) {
          this.wxActions.onVoiceRecordEnd(id => {
            this.recordId = id;
            this.wishInfo.voiceUrl = id;
            clearInterval(this.recordTimer);
          });
        }
        if (this.recordId != "") {
          this.wxActions.upload(this.recordId, data => {
            console.log("endmediaid", id);
            this.recordServerId = data["serverId"];
            console.log("endserverId-data", data);
          });
        } else {
          clearInterval(this.recordTimer);
          this.showMsg("录音失败，请刷新页面再试");
          this.soundRecordDel();
        }
      });
      this.soundRecording = false;
      clearInterval(this.recordTimer);
      if (allTime < 10) {
        this.soundRecordTime = "00:0" + allTime;
      } else if (allTime < 59) {
        this.soundRecordTime = "00:" + allTime;
      } else if (allTime > 59) {
        this.soundRecordTime = "01:00";
      }
    },
    recordPlayFun(event) {
      if (event.target.classList.contains("play")) {
        event.target.classList.remove("play");
        clearInterval(this.playTimer);
        this.wxActions.stopVoice(this.recordId);
        this.recordPlayProgress.width = "0%";
        this.soundRecordTimePlay = "00:00";
      } else {
        //初始化播放时间
        let time = 0;
        this.soundRecordTimePlay = "00:00"; //初始化播放事件
        event.target.classList.add("play");
        this.wxActions.playVoice(this.recordId);
        let recordTime =
          parseInt(this.soundRecordTime.split(":")[1]) > 0
            ? parseInt(this.soundRecordTime.split(":")[1])
            : 60;
        this.playTimer = setInterval(() => {
          time++;
          if (time > recordTime) {
            clearInterval(this.playTimer);
            return;
          }
          if (time < 10) {
            this.soundRecordTimePlay = "00:0" + time;
          } else if (time < 59) {
            this.soundRecordTimePlay = "00:" + time;
          } else if (time > 59) {
            this.soundRecordTimePlay = "01:00";
            clearInterval(this.playTimer);
          }
          console.log("playtime", time, recordTime);
          this.recordPlayProgress.width = (time / recordTime) * 100 + "%";
          if (time / recordTime == 1) {
            event.target.classList.remove("play");
            this.wxActions.stopVoice(this.recordId);
            clearInterval(this.playTimer);
          }
        }, 1000);
      }
    },
    soundRecordDel() {
      this.recordId = "";
      this.recordPlayProgress.width = "0%";
      this.soundRecordTime = "00:00";
      this.soundRecordTimePlay = "00:00";
      this.sureDialog = false;
      this.recordBtnStaus = 1;
    },
    resetIos8DialogTop() {
      let scrollWrap = document.querySelector(".scroll-container");
      let widowA = window.screen.availHeight;
      var top = scrollWrap.scrollTop + widowA / 2 + 130;
      console.log("重置弹框top", scrollWrap.scrollTop, widowA, top);
      document.querySelector(".self-dialog-content").style.top = top + "px";
      // console.log("重置后的高度",dialogContent.style.top)
    },
    initShare() {
      var shareTitle =
        "快来给" +
        this.birthdayPersonInfo.birthday +
        "生日的" +
        this.birthdayPersonInfo.department +
        this.birthdayPersonInfo.realName +
        "送生日祝福啦~~~";
      var shareDesc = "小手点一点，刷一波祝福，助TA登上锦鲤的宝座~";
      var shareImg =
        window.location.origin + "/static/assets/img/personal_share.jpg";
      // this.require(['aghojs'], function() {
      console.log("check shareINFO");
      this.wxShareData.allowShare = true;
      this.ddShareData.type = 0;
      this.share_info = {
        url: window.location.href,
        title: shareTitle,
        description: shareDesc,
        imgUrl: shareImg
      };
      if(this.project_name !== 'changjiangcunchu') {
            new agho.DdShare(this.ddShareData.type, this.share_info);
            if (this.isWX()) {
                //初始化录音接口对象
                if(!window.show_open_data || window.show_open_data === undefined){
                    this.wxActions = new WxRecord(() => {
                        try{
                            wx.updateAppMessageShareData(this.getShareData());
                            wx.updateTimelineShareData(this.getShareData());
                        }catch(err){
                            console.log(err)
                        }
                    });
                }else{
                    this.wxActions = window.wxActions;
                    try{
                        wx.updateAppMessageShareData(this.getShareData());
                        wx.updateTimelineShareData(this.getShareData());
                    }catch(err){
                        console.log(err)
                    }
                }
                
            }
      };
      
    },
    getShareData() {
      var baseShareData = {
        title: this.share_info.title,
        desc: this.share_info.description,
        link: this.share_info.url,
        imgUrl: this.share_info.imgUrl,
        success: function() {},
        cancel: function() {}
      };
      return baseShareData;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isShowLoading = true;
    });
    if (this.userLoginFinish) {
      this.initPageData();
    }
  }
};
</script>
